import { render, staticRenderFns } from "./PanelDatos.vue?vue&type=template&id=f4124706&scoped=true&"
import script from "./PanelDatos.vue?vue&type=script&lang=js&"
export * from "./PanelDatos.vue?vue&type=script&lang=js&"
import style0 from "./PanelDatos.vue?vue&type=style&index=0&id=f4124706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4124706",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VFlex,VLayout})
